import { preventDefault } from "@frui.ts/views/dist";
import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import React from "react";
import { translateGeneral } from "utils/localizations";

export interface HeaderWithBackButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  titleClassName?: string;
  level?: number;
  back: {
    text?: string;
    link?: string;
    action: () => void;
  };
  actionButton?: React.ReactNode;
}

export const headerWithBackButton = (props: HeaderWithBackButtonProps) => {
  const { title, titleClassName, level, back, className, actionButton, ...rest } = props;
  const headingElement = React.createElement(`h${level ?? 3}`, { className: `text-center mb-0 ${titleClassName}` }, title);

  return (
    <div className={`row align-items-center ${className}`} {...rest}>
      <div className="col-auto">
        <a onClick={preventDefault(back.action)} href={back.link ?? "#"} className="d-flex align-items-baseline">
          <Button iconLeft={IconType.ArrowLeft} variant="danger" size="sm" className="mr-2" />
          <span className="text-dark font-weight-bold link-underline">{back.text ?? translateGeneral("back")}</span>
        </a>
      </div>
      <div className="col">{headingElement}</div>
      {actionButton && <div className="col-auto">{actionButton}</div>}
    </div>
  );
};

export default headerWithBackButton;
